// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".case-warning-containar {\n  display: flex;\n  align-items: center;\n  height: 48px;\n  padding: 0 20px;\n  margin: 2px 0;\n  font-size: 14px;\n  font-weight: 500;\n  background-color: #fcedd3;\n  border-left: 20px solid #ffa726;\n  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),\n    0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);\n  box-sizing: content-box;\n}\n", ""]);
// Exports
module.exports = exports;
